import React, { useLayoutEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { formations, experiences } from '../../data/cursus';
import '../../styles/parcours.css';

gsap.registerPlugin(ScrollTrigger);

const TABS = [
  { id: 'xp', label: 'Expériences', items: experiences },
  { id: 'formation', label: 'Formations', items: formations }
];

const Parcours = () => {
  const [tab, setTab] = useState('xp');
  const active = TABS.find((t) => t.id === tab);
  const friseRef = useRef(null);

  // Le fil se trace à la position de la barre de défilement, pas sur un
  // déclencheur : il indique où on en est, il n'annonce pas une arrivée.
  // Recréé à chaque changement d'onglet, la frise changeant de hauteur.
  useLayoutEffect(() => {
    const el = friseRef.current;
    if (!el) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { '--avancee': 0 },
        {
          '--avancee': 1,
          ease: 'none',
          scrollTrigger: { trigger: el, start: 'top 78%', end: 'bottom 72%', scrub: 0.6 }
        }
      );
    }, el);

    return () => ctx.revert();
  }, [tab]);

  return (
    <section className="section parcours" id="parcours">
      <div className="shell">
        <div className="parcours-top">
          <div className="section-head parcours-head">
            <h2>Six ans entre code et design</h2>
          </div>

          <div className="parcours-tabs" role="tablist" aria-label="Filtrer le parcours">
            {TABS.map((t) => (
              <button
                key={t.id}
                role="tab"
                type="button"
                id={`tab-${t.id}`}
                aria-selected={tab === t.id}
                aria-controls={`panel-${t.id}`}
                className={`parcours-tab ${tab === t.id ? 'is-active' : ''}`}
                onClick={() => setTab(t.id)}
              >
                {t.label}
                <span className="parcours-tab-count">{t.items.length}</span>
              </button>
            ))}
          </div>
        </div>

        <ol
          className="timeline"
          ref={friseRef}
          id={`panel-${active.id}`}
          role="tabpanel"
          aria-labelledby={`tab-${active.id}`}
        >
          {active.items.map((item, i) => (
            <li
              className="timeline-item"
              key={item.id}
            >
              <span className="timeline-years">{item.years}</span>

              <span className="timeline-node" aria-hidden="true" />

              <div className="timeline-card">
                <div className="timeline-card-top">
                  <span className="timeline-label">{item.label}</span>
                  {item.duration && (
                    <span className="timeline-duration">{item.duration}</span>
                  )}
                </div>
                <h3 className="timeline-title">{item.title}</h3>
                <p className="timeline-place">{item.place}</p>
                <p className="timeline-desc">{item.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Parcours;
